import { kgDrawerHttpApi } from "../api";
import type {
  KgDataSourceUsedInParams,
  KgDrawerListParams,
  KgSchemaRelationshipsParams,
  KgSchemaUsedInParams,
} from "./kgDrawerApi.types";

/**
 * KG inspector drawer — thin service over `kgDrawerHttpApi` (global registry).
 * Hooks call `kgDrawerApi.ts`, which routes mock vs live through this service.
 */
export const kgDrawerService = {
  getNodeOverview: (nodeId: string) => kgDrawerHttpApi.getNodeOverview(nodeId),

  getDataSourceOverview: (dataSourceId: string) =>
    kgDrawerHttpApi.getDataSourceOverview(dataSourceId),

  getTableOverview: (schemaId: string) =>
    kgDrawerHttpApi.getTableOverview(schemaId),

  getDataSourceTables: (dataSourceId: string, params?: KgDrawerListParams) =>
    kgDrawerHttpApi.getDataSourceTables(dataSourceId, params),

  getDataSourceReports: (dataSourceId: string, params?: KgDrawerListParams) =>
    kgDrawerHttpApi.getDataSourceReports(dataSourceId, params),

  getDataSourceUsedIn: (
    dataSourceId: string,
    params?: KgDataSourceUsedInParams,
  ) => kgDrawerHttpApi.getDataSourceUsedIn(dataSourceId, params),

  getSchemaRelationships: (
    schemaId: string,
    params?: KgSchemaRelationshipsParams,
  ) => kgDrawerHttpApi.getSchemaRelationships(schemaId, params),

  getSchemaMetrics: (schemaId: string, params?: KgDrawerListParams) =>
    kgDrawerHttpApi.getSchemaMetrics(schemaId, params),

  getSchemaUsedIn: (schemaId: string, params?: KgSchemaUsedInParams) =>
    kgDrawerHttpApi.getSchemaUsedIn(schemaId, params),

  getOntologyOverview: (ontologyId: string) =>
    kgDrawerHttpApi.getOntologyOverview(ontologyId),

  getOntologyLinks: (ontologyId: string, params?: KgDrawerListParams) =>
    kgDrawerHttpApi.getOntologyLinks(ontologyId, params),

  getOntologyMetrics: (ontologyId: string, params?: KgDrawerListParams) =>
    kgDrawerHttpApi.getOntologyMetrics(ontologyId, params),

  getOntologyRules: (ontologyId: string) =>
    kgDrawerHttpApi.getOntologyRules(ontologyId),

  getOntologyReports: (ontologyId: string, params?: KgDrawerListParams) =>
    kgDrawerHttpApi.getOntologyReports(ontologyId, params),

  getOntologyUsedIn: (ontologyId: string, params?: KgSchemaUsedInParams) =>
    kgDrawerHttpApi.getOntologyUsedIn(ontologyId, params),

  getMetricOverview: (metricId: string) =>
    kgDrawerHttpApi.getMetricOverview(metricId),

  getMetricFormula: (metricId: string) =>
    kgDrawerHttpApi.getMetricFormula(metricId),

  getMetricUsedIn: (metricId: string, params?: KgSchemaUsedInParams) =>
    kgDrawerHttpApi.getMetricUsedIn(metricId, params),

  getReportOverview: (reportId: string) =>
    kgDrawerHttpApi.getReportOverview(reportId),

  getReportTrace: (reportId: string) =>
    kgDrawerHttpApi.getReportTrace(reportId),

  getReportUsedIn: (reportId: string, params?: KgSchemaUsedInParams) =>
    kgDrawerHttpApi.getReportUsedIn(reportId, params),

  getReportActivity: (reportId: string) =>
    kgDrawerHttpApi.getReportActivity(reportId),

  getDataStoryOverview: (dataStoryId: string) =>
    kgDrawerHttpApi.getDataStoryOverview(dataStoryId),

  getDataStoryTrace: (dataStoryId: string) =>
    kgDrawerHttpApi.getDataStoryTrace(dataStoryId),

  getDataStoryActivity: (dataStoryId: string) =>
    kgDrawerHttpApi.getDataStoryActivity(dataStoryId),

  getArtifactOverview: (artifactId: string) =>
    kgDrawerHttpApi.getArtifactOverview(artifactId),

  getArtifactActivity: (artifactId: string) =>
    kgDrawerHttpApi.getArtifactActivity(artifactId),

  getDataModelOverview: (dataModelId: string) =>
    kgDrawerHttpApi.getDataModelOverview(dataModelId),

  getDataModelTables: (dataModelId: string, params?: KgDrawerListParams) =>
    kgDrawerHttpApi.getDataModelTables(dataModelId, params),

  getDataModelMetrics: (dataModelId: string, params?: KgDrawerListParams) =>
    kgDrawerHttpApi.getDataModelMetrics(dataModelId, params),

  getDataModelRelationships: (
    dataModelId: string,
    params?: KgDrawerListParams,
  ) => kgDrawerHttpApi.getDataModelRelationships(dataModelId, params),
};
